import { useMemo, useState } from "react";
import { tastingItems, tastingTags } from "@/mocks/tastingItems";
import SectionHeading from "./SectionHeading";

const tagAccent: Record<string, string> = {
  甜口: "bg-primary-100 text-primary-800",
  咸香: "bg-secondary-100 text-secondary-900",
  辣味: "bg-primary-100 text-primary-800",
  酸爽: "bg-accent-100 text-accent-800",
  坚果: "bg-secondary-100 text-secondary-900",
  怀旧: "bg-background-200 text-foreground-700",
};

export default function Tasting() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(() => {
    if (active === "全部") return tastingItems;
    return tastingItems.filter((item) => item.tags.includes(active));
  }, [active]);

  return (
    <section
      id="tasting"
      className="w-full border-y border-background-200 bg-background-100"
    >
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="零食试吃清单"
          title="按口味筛选，看看哪一款对你胃口"
          desc="下面的清单来自不同主题盒中的单品。点击标签即可在海量记录里按口味筛选，每一条都附有品牌、参考价位与试吃后的具体感受。"
        />

        <div className="mt-6 flex flex-wrap gap-2">
          {tastingTags.map((tag) => {
            const isActive = tag === active;
            return (
              <button
                key={tag}
                type="button"
                onClick={() => setActive(tag)}
                aria-pressed={isActive}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-foreground-950 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-800"
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <p className="mt-4 text-xs text-foreground-500">
          当前共展示 {filtered.length} 款零食，数据来源于本页已有记录。
        </p>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading text-lg text-foreground-950">
                    {item.name}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-500">{item.brand}</p>
                </div>
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-accent-50 px-2.5 py-1 text-xs font-medium text-accent-800">
                  <i className="ri-sparkling-2-fill" />
                  {item.surprise.toFixed(1)}
                </span>
              </div>

              <div className="mt-3 flex flex-wrap gap-2">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`rounded-full px-2.5 py-1 text-xs ${
                      tagAccent[tag] ?? "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                {item.note}
              </p>

              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                <span className="text-xs text-foreground-500">参考价位</span>
                <span className="font-heading text-base text-foreground-950">
                  {item.price}
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}